import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import { routes } from "../General";
import axios from "axios";
import { Coberturas } from "./compModal/Coberturas";
import { FormaPrima } from "./compModal/FormaPrima";
import { Deducibles } from "./compModal/Deducibles";
import { Notas } from "./compModal/Notas";
import { Contratante } from "./Contratante";
import { DocsDigitalTabla } from "../siniestros/DocsDigitalTabla";

export class Condiciones extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.state = {
            value: "",
            editing: false,
            item: {},
            hTabs: "ht1",
            coberturas: [],
            docdigital: [],
            primas: [],
            docminio: [],
            clausulas: [],
            deducibles: [],
            exclusiones: [],
            notas: [],
        };
    }

    componentDidUpdate(prevProps) {
        let { open } = this.props;
        let openOld = prevProps.open;

        if (open !== openOld) {
            if (open) {
                this.fetchData();
            } else {
                this.setState({ item: {} });
            }
        }
    }

    fetchData() {
        let { item } = this.props;
        let docItem = this.props.poliza.cotizacion;
        this.getCoberturasVam(item.cdCompania, item.cdUbicacion);
        this.getFormaPrima(item.cdCompania, item.cdUbicacion);
        this.getDeducibles(item.cdCompania, item.cdUbicacion);
        this.getExclusiones(item.cdCompania, item.cdUbicacion);
        this.getNotas(item.cdRamoCotizacion);
        this.getClausulas(item.cdCompania, item.cdUbicacion);
        this.getDocDigital(docItem.cdCliente, docItem.cdCompania, docItem.cdCotizacion);
    }

    onClose = () => {
        let { item } = this.props;
        let docItem = this.props.poliza.cotizacion;
        this.getDocDigital(docItem.cdCliente, docItem.cdCompania, docItem.cdCotizacion);
    };

    getDocDigital = (cdcliente, cdcompania, cdcotizacion) => {
        axios
            .get(routes.api + "/docs", {
                params: {
                    tipo: "poliza",
                    cdCliente: cdcliente,
                    cdCompania: cdcompania,
                    cdCotizacion: cdcotizacion,
                },
            })
            .then(resp => {
                let res = resp.data;
                res.minio.map(rp => {
                    rp.metadato = JSON.stringify(rp.metadato);
                });
                (res.minio || []).forEach(datosTabla => {
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                    //Se encuentra doble serializado el JSON
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                });
                this.setState({ docdigital: res });
            })
            .catch(error => {
                // alert('Error al consultar' + error);
            });
    };

    getCoberturasVam = (idComp, cdUbicacion) => {
        //diferenciar a q peticion mandar
        axios
            .get(routes.api + "/polizas/vam/coberturas", {
                params: {
                    cdCompania: idComp,
                    cdUbicacion: cdUbicacion,
                },
            })
            .then(resp => {
                let cobs = resp.data;
                cobs = Object.entries(cobs);
                this.setState({ coberturas: cobs });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getFormaPrima = (idComp, cdUbicacion) => {
        axios
            .get(routes.api + "/polizas/formaPrima", {
                params: {
                    cdCompania: idComp,
                    cdUbicacion: cdUbicacion,
                },
            })
            .then(resp => {
                let primas = resp.data;
                this.setState({ primas: primas });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getDeducibles = (idComp, cdUbicacion) => {
        axios
            .get(routes.api + "/polizas/deducibles", {
                params: {
                    cdCompania: idComp,
                    cdUbicacion: cdUbicacion,
                },
            })
            .then(resp => {
                let deducibles = resp.data;
                this.setState({ deducibles: deducibles });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getExclusiones = (idComp, cdUbicacion) => {
        axios
            .get(routes.api + "/polizas/exclusiones", {
                params: {
                    cdCompania: idComp,
                    cdUbicacion: cdUbicacion,
                },
            })
            .then(resp => {
                let exclusiones = resp.data;
                this.setState({ exclusiones: exclusiones });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getNotas = cdRamoCoti => {
        axios
            .get(routes.api + "/polizas/notas", {
                params: {
                    cdRamosCotizacion: cdRamoCoti,
                },
            })
            .then(resp => {
                let notas = resp.data.sort((a1, a2) => a1.cdAclaratorio - a2.cdAclaratorio);
                this.setState({ notas: notas });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getClausulas = (idComp, cdUbicacion) => {
        axios
            .get(routes.api + "/polizas/clausulas", {
                params: {
                    cdCompania: idComp,
                    cdUbicacion: cdUbicacion,
                },
            })
            .then(resp => {
                let notas = resp.data;
                this.setState({ clausulas: notas });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    closeModal = () => {
        this.props.toggleModal(false);
        this.setState({ list: [], item: {} });
    };

    tabSelect = tab => {
        this.setState({ hTabs: tab });
    };

    render() {
        let ramos = this.props.ramos;
        return (
            <Modal className="text-center modal-xl mx-auto modal-detail" isOpen={this.props.open}>
                <ModalBody>
                    <div className="row">
                        <Contratante
                            poliza={this.props.poliza}
                            item={this.props.item}
                            user={this.props.user}
                            vida={this.props.vida}
                            ramos={ramos}
                        />

                        <div className="col-lg-9 pt-2">
                            <div className={"text-right"}>
                                <button
                                    type="button"
                                    className="close"
                                    title="Cerrar"
                                    onClick={() => {
                                        this.closeModal();
                                    }}
                                    aria-label={"Close"}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <h5 className="card-title">Detalle Póliza</h5>
                            {/*<NavItem className="cursorPointer">*/}
                            {/*    <NavLink*/}
                            {/*        className={this.state.hTabs === "ht2" ? "active" : ""}*/}
                            {/*        onClick={() => this.tabSelect("ht2")}>*/}
                            {/*        Dependientes*/}
                            {/*    </NavLink>*/}
                            {/*</NavItem>*/}

                            <Coberturas
                                hTabs={this.state.hTabs}
                                coberturas={this.state.coberturas}
                                vida={this.props.vida}
                            />
                            <div className="my-1" />
                            <FormaPrima hTabs={this.state.hTabs} primas={this.state.primas} />
                            <div className="my-1" />
                            <Deducibles hTabs={this.state.hTabs} deducibles={this.state.deducibles} />
                            <div className="my-1" />
                            <Notas hTabs={this.state.hTabs} notas={this.state.notas} />
                            <div className="my-1" />
                            <DocsDigitalTabla
                                hTabs={this.state.hTabs}
                                docdigital={this.state.docdigital}
                                tipo={"poliza"}
                                dato={this.props.poliza.cotizacion}
                                onClose={this.onClose}
                            />
                            <br />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}
